/*eslint-disable */
import toast from '@/services/toast';
import todoShare from './todo-share';
import { bus } from '@/main';
export default {
  name: 'todo-app',
  components: {
    'todo-share' : todoShare
  },
  props: [],
  data () {
    return {
      getToDoListData:null,
      getToDoListDataResults:[],
      title:'',
      removeToDoPopup:false,
      removeAllToDoPopup:false,
      removeToDoId:'',
      filterToDoActv:'All',
      getCompletedToDoListData:null,
      getCompletedToDoListDataResults:[],
      sharedToDoState:false,
      sharedToDoData:null,
      getSharedToDoListData:null,
      getSharedToDoListDataResults:[]

    }
  },
  computed: {

  },
  mounted () {
    this.getTodoListMethod();
    bus.$on('sharedToDoStateBus', (data) => {
      this.sharedToDoState = data;
    });
  },
  methods: {
    openToDoSharedPopupMethod(data){
      this.sharedToDoData = data
      this.sharedToDoState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    filterToDoActvMethod(flag){
      this.filterToDoActv = flag
      if(flag == 'Completed'){
        this.$store.dispatch('getFiltersToDoListAction',{status:'True'}).then((res) => {
          this.getCompletedToDoListData = res.data.data
          this.getCompletedToDoListDataResults = this.getCompletedToDoListData.results
        })
      }else if(flag == 'Pending'){
        this.$store.dispatch('getFiltersToDoListAction',{status:'False'}).then((res) => {
          this.getCompletedToDoListData = res.data.data
          this.getCompletedToDoListDataResults = this.getCompletedToDoListData.results
        })
      }else if(flag == 'Shared'){
        this.$store.dispatch('getSharedToDoListAction').then((res) => {
          this.getSharedToDoListData = res.data.data.shared_todo
          this.getSharedToDoListDataResults = this.getSharedToDoListData.results
        })
      }
    },
    getTodoListMethod(){
      this.$store.dispatch('getToDoListAction').then((res) => {
        this.getToDoListData = res.data.data
        this.getToDoListDataResults = this.getToDoListData.results
      })
    },
    createToDoInfoMethod(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          let data = {
            title : this.title
          }        
          this.$store.dispatch('postToDoListAction', data).then((res) => {
            this.title = ''
            this.submitted = false
            this.$validator.reset();
            this.getTodoListMethod();
          }).catch((err) => {
            this.submitted = false
          })
        }
      })
    },
    todoCompletemethod(data){
      var is_completed = false;
      if(data.is_completed == true){
        is_completed = false
      }else{
        is_completed = true
      }
      let payload = {
        id:data.id,
        is_completed : is_completed
      }        
      this.$store.dispatch('updateToDoInfoByIdAction', payload).then((res) => {
        if(this.filterToDoActv == 'Shared'){
          this.$store.dispatch('getSharedToDoListAction').then((res) => {
            this.getSharedToDoListData = res.data.data.shared_todo
            this.getSharedToDoListDataResults = this.getSharedToDoListData.results
          })
        }else{
          this.getTodoListMethod();
        }
      })
    },
    openAllToDoRemovePopup(){
      this.removeAllToDoPopup = true
    },
    closeRemoveAllItemModalFun(){
      this.removeAllToDoPopup = false
    },
    removeAllToDoConfirmationMethod(){
      this.$store.dispatch('allToDoRemoveAction').then((res) => {
        toast.success(res.data.data.results);
        this.closeRemoveAllItemModalFun();
        if(this.filterToDoActv == 'All'){
          this.getTodoListMethod();
        }else if(this.filterToDoActv == 'Completed'){
          this.$store.dispatch('getFiltersToDoListAction',{status:'True'}).then((res) => {
            this.getCompletedToDoListData = res.data.data
            this.getCompletedToDoListDataResults = this.getCompletedToDoListData.results
          })
        }else if(this.filterToDoActv == 'Pending'){
          this.$store.dispatch('getFiltersToDoListAction',{status:'False'}).then((res) => {
            this.getCompletedToDoListData = res.data.data
            this.getCompletedToDoListDataResults = this.getCompletedToDoListData.results
          })
        }
      })
    },
    openSelectedToDoRemovePopup(id){
      this.removeToDoPopup = true
      this.removeToDoId = id
    },
    closeRemoveItemModalFun(){
      this.removeToDoPopup = false
      this.removeToDoId = ''
    },
    removeToDoConfirmationMethod(){
      let payload = {
        id:this.removeToDoId
      }
      this.$store.dispatch('toDoRemoveByIdAction', payload).then((res) => {
        toast.success(res.data.data.results);
        this.closeRemoveItemModalFun();
        if(this.filterToDoActv == 'All'){
          this.getTodoListMethod();
        }else if(this.filterToDoActv == 'Completed'){
          this.$store.dispatch('getFiltersToDoListAction',{status:'True'}).then((res) => {
            this.getCompletedToDoListData = res.data.data
            this.getCompletedToDoListDataResults = this.getCompletedToDoListData.results
          })
        }else if(this.filterToDoActv == 'Pending'){
          this.$store.dispatch('getFiltersToDoListAction',{status:'False'}).then((res) => {
            this.getCompletedToDoListData = res.data.data
            this.getCompletedToDoListDataResults = this.getCompletedToDoListData.results
          })
        }
      })
    },
  }
}
